import type { InvoiceManagementPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import type { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';
import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { nothing } from 'lit';

export const defaultInvoiceManagementPlugin: InvoiceManagementPlugin<UserStammdaten> = {
  id: 'invoice-management::default',
  type: 'invoice-management',
  render: (stammdaten: UserStammdaten, scope: ChemistryLitElement) => nothing,
};
